//Inicialmente creado para manejar etiquetas personalizadas en documentos XML
//ahora es el parser de docxtemplater
//en el futuro se deberá eliminar cuando se reemplace doxctemplater por una libreria propia
import { funcionesCustom } from './funciones'
// import { getImage } from './imagenes'

// Soporte para rutas tipo productos[1].nombre
export const resolveValue = (scope, path) => {
  const regex = /([^[.\]]+)(\[\d+\])?/g
  let result = scope

  let match
  while ((match = regex.exec(path)) !== null) {
    const key = match[1]
    const indexPart = match[2]

    if (result === undefined || result === null) return '';
    if (typeof result !== 'object') return ''; // Evita acceder a propiedades de strings/números

    result = result?.[key]
    if (indexPart && result) {
      const index = parseInt(indexPart.replace(/\[|\]/g, ''), 10)
      result = result[index]
    }

  }

  return result ?? ''
}

export const parser = (tag) => {
  const fnRegex = /^fn(\w+):\(([^)]+)\)$/
  const forRegex = /^for:(.+)$/
  const foriRegex = /^fori:(.+)$/
  const imageRegex = /^i:(.+)$/
  const varRegex = /^v:(.+)$/

  // Funciones personalizadas
  if (fnRegex.test(tag)) {
    const [, fnName, argsRaw] = tag.match(fnRegex)
    const args = argsRaw.split(',').map((x) => x.trim())
    return {
      get: (scope) => {
        const valores = args.map((arg) => resolveValue(scope, arg))
        return funcionesCustom[fnName]?.(...valores) ?? ''
      },
    }
  }

  // Imágenes
  if (imageRegex.test(tag)) {
    const [, path] = tag.match(imageRegex)
    return {
      get: () => `\${i:${path}}`,
      isImage: true, // Marca especial para saber que es imagen
      path, // Por si necesitas el path de la variable
    }
  }

  // For personalizado (no usado directamente)
  if (forRegex.test(tag)) {
    const [, arrName] = tag.match(forRegex)
    return {
      get: (scope) => resolveValue(scope, arrName) ?? [],
    }
  }

  // Variables normales y fori
  if (foriRegex.test(tag) || varRegex.test(tag)) {
    const [, path] = tag.match(foriRegex) || tag.match(varRegex)
    return {
      get: (scope) => resolveValue(scope, path) ?? '',
    }
  }

  // Fallback
  return {
    get: (scope) => resolveValue(scope, tag) ?? '',
  }
}
